<script>
export default {
  name: 'EasierBudgetingIcon',
}
</script>
<template>
  <svg width="52px" height="52px" viewBox="0 0 52 52" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>ic_easy_budgeting</title>
      <g id="Design" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
          <g id="Desktop-HD-2-Rev" transform="translate(-284.000000, -2545.000000)" stroke="#FFFFFF">
              <g id="Benefits" transform="translate(0.000000, 1597.000000)">
                  <g id="Proofpoints" transform="translate(252.000000, 726.000000)">
                      <g id="ic_easy_budgeting" transform="translate(33.000000, 223.000000)">
                          <g>
                              <path d="M38,25 C38,32.18 32.18,38 25,38 C17.82,38 12,32.18 12,25 C12,17.82 17.82,12 25,12 C32.18,12 38,17.82 38,25 Z" id="Stroke-1" stroke-width="2"></path>
                              <path d="M50,25 C50,38.807 38.807,50 25,50 C11.193,50 0,38.807 0,25 C0,11.193 11.193,0 25,0 C38.807,0 50,11.193 50,25 Z" id="Stroke-3" stroke-width="2"></path>
                              <line x1="25" y1="0" x2="25" y2="12" id="Stroke-5" stroke-width="2"></line>
                              <line x1="37.5" y1="3.3496" x2="31.5" y2="13.7416" id="Stroke-7" stroke-width="2"></line>
                              <line x1="46.6504" y1="12.5" x2="36.2574" y2="18.5" id="Stroke-9" stroke-width="2"></line>
                              <line x1="50" y1="25" x2="38" y2="25" id="Stroke-11" stroke-width="2"></line>
                              <line x1="3.3496" y1="37.5" x2="13.7416" y2="31.5" id="Stroke-13" stroke-width="2"></line>
                              <line x1="46.6504" y1="37.5" x2="36.2574" y2="31.5" id="Stroke-15" stroke-width="2"></line>
                              <path d="M28,21 L24,21 C22.896,21 22,21.896 22,23 C22,24.104 22.896,25 24,25 L26,25 C27.104,25 28,25.896 28,27 C28,28.104 27.104,29 26,29 L22,29" id="Stroke-17" stroke-width="2"></path>
                              <line x1="25" y1="18" x2="25" y2="21" id="Stroke-19" stroke-width="2"></line>
                              <line x1="25" y1="29" x2="25" y2="32" id="Stroke-21" stroke-width="2"></line>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </g>
  </svg>
</template>
